import React, { SyntheticEvent, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Page from "../../components/Page";
import "./index.css";
import { Box, AlertColor } from "@mui/material";
import { Form } from "react-bootstrap";
import config, { getConfigForRegion, Region, Regions, ApiCompanyData } from "../../config";

import CustomSnackbar from "../../components/CustomSnackbar";
import CustomButton from "../../components/CustomButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAuth } from "../../context/AuthContext";

const { ID_CREATE_NEW } = config?.app;
//const { CREATE_COMPANY, API_FAIL_ERROR } = config?.api;
// const { CREATE_COMPANY, UPDATE_COMPANY, API_FAIL_ERROR } = config?.api;
const HEADER_NAME = "";

const Company = () => {
    const { companyId } = useParams();
    const navigate = useNavigate();
    const { isAuthenticating, refreshCompanies, companies, headersWithAuth } = useAuth();
    // adding new code for back button
    const isCreatingNew = companyId === ID_CREATE_NEW;

    const [initialCompanyData, setInitialCompanyData] = useState<ApiCompanyData | undefined>(undefined);
    const [updatedCompanyData, setUpdatedCompanyData] = useState<ApiCompanyData | undefined>(undefined);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor>("success");
    const [isLoading, setIsLoading] = useState(false);
    const [region, setRegion] = useState<Region>(Regions.Canada);
    const [currentConfig, setCurrentConfig] = useState(config);

    useEffect(() => {
        setCurrentConfig(getConfigForRegion(region));
    }, [region]);

    const handleRegionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedRegion = Object.values(Regions).find((r) => r.id === e.target.value);
        if (selectedRegion) {
            setRegion(selectedRegion);
        }
    };

    const handleSnackbarClose = (event: SyntheticEvent<any, Event> | Event, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSnackbar(false);
    };

    const isCompanyChanged = (): boolean => {
        const noChange =
            !!initialCompanyData && !!updatedCompanyData && Object.is(initialCompanyData, updatedCompanyData);
        return !noChange;
    };

    const validateCompanyName = (companyName?: string) => !companyName || companyName.length <= 64;

    const isDataValid = (): boolean => {
        const companyName = updatedCompanyData?.name || "";
        return (
            validateCompanyName(companyName) && companyName.trim() !== "" // Check if company name is not blank
        );
    };

    // useEffect(() => {
    //   if (!isAuthenticating && !isAuthenticated) {
    //     navigate("/login");
    //   }
    // });

    useEffect(() => {
        if (!isCreatingNew && companies && companyId) {
            const urlParams = new URLSearchParams(window.location.search);
            const urlRegion = urlParams.get("region");

            // Find company by matching both ID and region
            const companyFromId = companies.find(
                (company) => company.id.toString() === companyId && company.region === urlRegion
            );

            if (companyFromId) {
                setUpdatedCompanyData(companyFromId);
                setInitialCompanyData(companyFromId);

                // Set region to Canada (default)
                setRegion(Regions.Canada);
            }
        }
    }, [companyId, companies, isCreatingNew]);

    // useEffect(() => {
    //   if (companies) {
    //     const companyFromId = companies.find(
    //       (company) => company.id.toString() === companyId
    //     );
    //     setUpdatedCompanyData(companyFromId);
    //     setInitialCompanyData(companyFromId);
    //   }
    // }, [companyId, companies]);

    const handleUpdate = (e: React.ChangeEvent<HTMLInputElement>, prop: string) => {
        const newCompanyData: ApiCompanyData = {
            ...(updatedCompanyData as ApiCompanyData)
        };

        (newCompanyData as any)[prop] = e.target.value;

        console.log(`After update newCompanyData:`, newCompanyData);
        setUpdatedCompanyData(newCompanyData);
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        const sendRequest = async () => {
            const companies = [
                {
                    id: updatedCompanyData?.id,
                    name: updatedCompanyData?.name,
                    ...(updatedCompanyData?.address1 ? { address1: updatedCompanyData?.address1 } : {}),
                    ...(updatedCompanyData?.address2 ? { address2: updatedCompanyData?.address2 } : {}),
                    ...(updatedCompanyData?.city ? { city: updatedCompanyData?.city } : {})
                }
            ];

            let userAction = isCreatingNew ? "Created" : "Updated";
            try {
                setIsLoading(true);

                setOpenSnackbar(true);
                setSnackbarMessage(
                    `Started ${isCreatingNew ? "creating" : "updating"} the company: ${updatedCompanyData?.name} ...`
                );
                setSnackbarSeverity("success");
                let createCompanyResponse;
                if (!isCreatingNew) {
                    console.log("entered update condition");
                    createCompanyResponse = await axios.post(
                        `${currentConfig.api.UPDATE_COMPANY}`,
                        {
                            id: updatedCompanyData?.id,
                            name: updatedCompanyData?.name,
                            ...(updatedCompanyData?.address1 ? { address1: updatedCompanyData?.address1 } : {}),
                            ...(updatedCompanyData?.address2 ? { address2: updatedCompanyData?.address2 } : {}),
                            ...(updatedCompanyData?.city ? { city: updatedCompanyData?.city } : {})
                        },
                        headersWithAuth
                    );
                } else {
                    createCompanyResponse = await axios.post(
                        `${currentConfig.api.CREATE_COMPANY}`,
                        { companies },
                        headersWithAuth
                    );
                    console.log("entered create condition");
                }
                const errorCode = createCompanyResponse?.data[0]?.errorCode;
                if (errorCode) {
                    setSnackbarMessage(`${createCompanyResponse?.data[0]?.message}`);
                    setSnackbarSeverity("error");
                } else if (createCompanyResponse?.status >= 400) {
                    //console.log(createCompanyResponse);
                    console.log(`${userAction} ${config.api.API_FAIL_ERROR}${createCompanyResponse.status}`);
                    setSnackbarMessage(
                        `${userAction} Company  ${currentConfig.api.API_FAIL_ERROR}${createCompanyResponse?.status}`
                    );
                    setSnackbarSeverity("error");
                } else {
                    console.log(`${userAction}`);
                    setSnackbarMessage(`Company ${userAction} successfully!`);
                    setSnackbarSeverity("success");
                    return true;
                }
                //const newCompanyData: ApiCompanyData = response.data;
            } catch (e) {
                console.log(`${userAction} ${currentConfig.api.API_FAIL_ERROR}`);
                setSnackbarMessage(`${userAction} Company ${currentConfig.api.API_FAIL_ERROR}${e}`);
                setSnackbarSeverity("error");
            }
        };

        await sendRequest();
        refreshCompanies();
        setUpdatedCompanyData(undefined);
        setIsLoading(false);
        setOpenSnackbar(true);
    };

    const pageTitle = isCreatingNew ? `New Company` : `Company Id: ${companyId}`;

    const name = updatedCompanyData?.name || "";
    const address1 = updatedCompanyData?.address1 || "";
    const address2 = updatedCompanyData?.address2 || "";
    const city = updatedCompanyData?.city || "";

    return (
        <Page name={HEADER_NAME} isAuthenticating={isAuthenticating}>
            <Box className="home-container py-3">
                <Box sx={{ padding: 2 }}>
                    <h1 data-cy={`pageTitle${companyId ? `-${companyId}` : ""}`}>{pageTitle}</h1>
                    <hr />
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3" controlId="formName">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                value={name}
                                maxLength={64}
                                onChange={(e: any) => handleUpdate(e, "name")}
                            />
                            <small
                                style={{
                                    fontStyle: "italic",
                                    color: "grey",
                                    fontSize: "0.8em" // Adjust the size as needed
                                }}
                            >
                                Company Name should not be greater than 64 characters and it cannot be blank. (current
                                length: {name.length})
                            </small>
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formAddress1">
                            <Form.Label>Address line 1</Form.Label>
                            <Form.Control
                                type="text"
                                value={address1}
                                onChange={(e: any) => handleUpdate(e, "address1")}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formAddress2">
                            <Form.Label>Address line 2</Form.Label>
                            <Form.Control
                                type="text"
                                value={address2}
                                onChange={(e: any) => handleUpdate(e, "address2")}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="formCity">
                            <Form.Label>City</Form.Label>
                            <Form.Control type="text" value={city} onChange={(e: any) => handleUpdate(e, "city")} />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formRegion">
                            <Form.Label>Region</Form.Label>
                            <Form.Select value={region.id} onChange={handleRegionChange} disabled={!isCreatingNew}>
                                {Object.values(Regions).map((r) => (
                                    <option key={r.id} value={r.id}>
                                        {r.displayName}
                                    </option>
                                ))}
                            </Form.Select>

                            {!isCreatingNew && (
                                <small className="text-muted">Region cannot be changed after company creation</small>
                            )}
                        </Form.Group>

                        <Box display="flex" gap={2}>
                            {/* <BackButton>Back</BackButton> */}

                            <CustomButton
                                size="medium"
                                type="button"
                                isLoading={false}
                                variant="outlined"
                                text="Go Back"
                                icon={ArrowBackIcon}
                                onClick={() => navigate(-1)}
                            />

                            <CustomButton
                                size="medium"
                                type="submit"
                                disabled={!isCompanyChanged() || !isDataValid() || isLoading}
                                isLoading={isLoading}
                                text="Submit"
                            />
                        </Box>
                    </Form>
                </Box>
            </Box>

            <CustomSnackbar
                open={openSnackbar}
                handleClose={handleSnackbarClose}
                message={snackbarMessage}
                severity={snackbarSeverity}
            />
        </Page>
    );
};

export default Company;
